import { forwardRef } from "react";

import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { PanelBoxV2 } from "@/tpo/Boxes";
import { ChartCardWrapper, RetestDueSubTitle } from "@/tpo/ChartCards";
import { dueForRetestOrExpired } from "@/utils/shared";

import DatapointCharts from "../../DatapointCharts";
import DatapointGraph from "../../DatapointGraph";
import { USER_DATAPOINTS_QUERY } from "./graphql";

const DatapointChartCard = forwardRef(({ onClick, userDatapoint }, ref) => {
  const isGenesAlleles = userDatapoint.datapoint.chartType === "GENES_ALLELES_CHART";
  const orgContext = useOrganisationContext();
  const organisationId = orgContext?.organisationId;

  return (
    <PanelBoxV2
      maxWidth={760}
      outer={{
        bg: "white",
        borderRadius: 5,
        cursor: "pointer",
        px: [20],
        py: [20]
      }}
      ref={ref}
    >
      <ChartCardWrapper
        title={userDatapoint.datapoint.name}
        subtitle={
          dueForRetestOrExpired(userDatapoint.dueForRetest, userDatapoint.dateExpired) &&
          !isGenesAlleles && <RetestDueSubTitle />
        }
        chart={<DatapointCharts datapoint={userDatapoint} />}
        onClick={onClick}
        showCotIcon={!isGenesAlleles}
        cotChart={
          <DatapointGraph
            query={USER_DATAPOINTS_QUERY}
            userDatapoint={userDatapoint}
            skip={!organisationId}
          />
        }
      />
    </PanelBoxV2>
  );
});

DatapointChartCard.defaultProps = {
  includeRelatedResults: true
};

export default DatapointChartCard;
